<mat-form-field class="w-100">
	<input
		matInput
		[required]="required"
		[readonly]="dateControl.value"
		[formControl]="dateControl"
		(click)="datePicker.open()"
		(keyup)="onKeyUp($event.key)"
		[matDatepicker]="datePicker"
		autocomplete="off"
		[placeholder]="placeholder"
		#dateInput
	/>
	<button
		*ngIf="clearable"
		mat-button
		matSuffix
		mat-icon-button
		arial-label="Clear"
		(click)="clearValue()"
	>
		<mat-icon>close</mat-icon>
	</button>
	<mat-datepicker-toggle
		#toggle
		matSuffix
		[for]="datePicker"
	></mat-datepicker-toggle>
	<mat-datepicker #datePicker></mat-datepicker>
	<mat-hint *ngIf="hint">{{ hint }}</mat-hint>
	<mat-error *ngIf="dateControl.hasError('required')">Required</mat-error>
</mat-form-field>
